import { render, staticRenderFns } from "./createPNG.dialog.vue?vue&type=template&id=2227434c&scoped=true"
import script from "./createPNG.dialog.vue?vue&type=script&lang=js"
export * from "./createPNG.dialog.vue?vue&type=script&lang=js"
import style0 from "./createPNG.dialog.vue?vue&type=style&index=0&id=2227434c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2227434c",
  null
  
)

export default component.exports